import './App.css';
import './Header.css';
import Header from './Header';
import Home from './Home';
import Checkout from './Checkout';
import Login from './Login';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { auth } from './Firebase';
import { onAuthStateChanged } from 'firebase/auth';

function App() {
  const [user, setUser] = useState(null);
  const [searchTerm, setSearchTerm] = useState(''); // ⬅️ New state for search

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  return (
    <div className="App">
      <Router>
        <Routes>
          <Route
            path="/login"
            element={<Login />}
          />

          <Route
            path="/checkout"
            element={
              <>
                <Header user={user} searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
                <Checkout />
              </>
            }
          />

          <Route
            path="/"
            element={
              <>
                <Header user={user} searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
                <Home searchTerm={searchTerm} />
              </>
            }
          />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
